export const LoadState = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
};

export const SubmissionState = {
  IDLE: 'IDLE',
  SUBMITTING: 'SUBMITTING',
  SUBMITTED: 'SUBMITTED',
  ERROR: 'ERROR',
};

export const LoadingState = {
  IDLE: 'Idle',
  LOADING: 'Loading',
  LOADED: 'Loaded',
  ERROR: 'Error',
};

export const defaultOrderPagination = {
  currentPage: 1,
  totalPages: 0,
  pageSize: 10,
  totalCount: 0,
  hasPrevious: false,
  hasNext: false,
};
